








import { GPageBase } from '@/mixins';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { PsychologicalSafety } from '@/models/school-group/school-group-trend-analysis';
import { statisticsModule } from '@/store/modules/frames/statistics.module';
import GTrendAnalysisPsychologicalSafetyChart from '@/views/GClassManagement/GTrendAnalysisPsychologicalSafetyChart.vue';

@Component({
  name: 'GClassManagementTrendAnalysisPsychologicalSafety',
  components: {
    GTrendAnalysisPsychologicalSafetyChart,
  },
})
export default class GClassManagementTrendAnalysisPsychologicalSafety extends mixins(GPageBase) {
  mounted() {}

  get schoolGroupTrendAnalysisPsychologicalSafety(): PsychologicalSafety {
    return statisticsModule.schoolGroupTrendAnalysis.psychologicalSafety;
  }
}
